import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable, takeUntil } from 'rxjs';

import {
  AddNumbersToClubCommand,
  ComparisonObjectsWithLogicalOperators,
  ComparisonOperator,
  GetEnumValuesDto,
  GetNumbersAggregatorDto,
  GetNumbersAggregatorQuery,
} from 'src/app/core/api/models';
import { AggregatorsService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { BaseIndexModule } from 'src/app/pages/shared/base/modules/base-index.module';
import { BaseIndexPageComponent } from 'src/app/pages/shared/base/components/base-index-page.component';


@Component({
    selector: 'app-numbers-aggregator-list',
    templateUrl: './numbers-aggregator-list.component.html',
    imports: [BaseIndexModule],
    styles: [
        `
      fieldset {
        border: none !important;
      }
    `,
    ]
})
export class NumbersAggregatorListComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region porperties

  @Input('model') selectedModel: GetNumbersAggregatorQuery = {};

  items: Array<GetNumbersAggregatorDto> = [];
  baseItems: Array<GetNumbersAggregatorDto> = [];
  filteredItems: Array<GetNumbersAggregatorDto> = [];

  isTableFiltered: boolean = false;

  model: AddNumbersToClubCommand = {};
  mobileNumbers: string;
  SmsAggregatorsEnumValues: GetEnumValuesDto[] = [];

  @Output('closePage') output_closePage = new EventEmitter<boolean>();

  //#endregion
  constructor(protected currentService: AggregatorsService) {
    super();
  }
  //#region init methods

  ngOnInit() {
    try {
      this.getVocabs();
      this.configTableColumns();
      this.initTablePagination();
      this.configPage();
      this.getTableData();
      this.getEnumsValues();
      this.pageConfig.title = 'pages.numbersAggregator.numbersAggregatorList';
      this.pageConfig.showAddBtn = false;
      this.pageConfig.showAuditBtn = false;
      this.pageConfig.showHelpBtn = false;
      this.pageConfig.tableConfig.showOperationColumn = false;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  configTableColumns(): void {
    this.tableColumns = [
      {
        title: 'common.number',
        name: 'number',
        hasSearch: true,
        noSorting: true,
        customOperators: [ComparisonOperator.Contains],
      },
      {
        title: 'common.aggregator',
        name: 'mobileOperator',
        type: 'enum',
        enumName: 'SmsAggregator',
        noSorting: true,
        hasSearch: true,
      },
    ];
  }

  //#endregion

  //#region api

  getTableData() {
    this.unSubs();
    this.pageConfig.loading = true;
    // const body = { "numbers": "JwDmEZgJgNgBmDAzOANKC17ReslY4QYB2EPTQkKAFjgoOxhigawUXo0YSSi-xZwcZCTaFoNYOPggkAVnkUkJGiHAt5MZfI2IYGmUXkkBleCSiqjpqUZAjt3dmRjTnhEiXlIb61h4WwHBmPG4kToKewME2cDRKgSK6NEbItGk0NGJJbjCpuVDAOVHwMCDWuSTCmXBouQa+ubrupSLQiW35UAFt8uqR5nDyoCVD-epp8YNhyWngWmlF9V0LreNyM+zwPka6k0m64AV9UHxG2cBNbUggIJ1DWUih7DTlDzzP4CtDUD5bhDoFSMz3uRisbhBKhOv2860+C2uvwcPx42SKRg04F6vwWOJ4iI+7EgwBhPDOiyS2POSR64HIVJIEExOExCDG5KQxXBKAB8B68HBcEqbSgkBehGG2XEIxGxxlrnkZPYIUQMqucBpbQQInVWRiRk1Bo8I2YNCRBDlxQtHWAJn4hp8qNtpOQMocSC1lBG0DI7ocfwV0JtfwiVg5HW8Svhkae+MjzEMJpIKD9yb+dAVwrdyfpdnTRQZURMqYjoeOKhlpDAEqVCQdJpoZwcMoScCsrbu3lbE2dfx8SEzjYW5qrKDUneEIaVa3jGanZcUpBGMpGqkXUksAK0+Wlw5oSeLTxF3vNFVrajkyozWlJY+OG+ExuLBlg26bXj7M81Re9Wnk8Stu2RBARoi7tm2MoqD0v6WioKjgRokImiEFSPnU24IJcMrstUOFEOUMp-CoMZ-Ag544cQgaNhh05SggMrCKI4ibuASAAlIB7YixnD5DxpjDDxdwHkJIBNjxoA9Dx2B9lI5QNlEcnZixaGVh4aj6HOUj9hK2SkBO6lXNCPF1Ls6kRFosGSMQxCyfc5paVc8jUYp9y0CGenrixKa3GW2TPG83m3GJ3nCpqLG7i5lB6UqfkwEq7HeRo4XmZ6YARfpWmKP0ukjCgRK0LFOaKf03iySwwqkQkXjUBFVhqup8C+XV6hVWUUBWYVlwcSM8QeSYxA9R1ZmKVIpJVc5KCyUqxgsWofxVeazCLZuulZM5qRAAA$$" };
    // this.selectedModel
    this.currentService
      .aggregatorsGetNumbersAggregator({ body: this.selectedModel })
      .pipe(this.basePipeOperators())
      .subscribe((result) => {
        this.baseItems = Object.assign([], result?.data);
        this.getPaginationData();
      });
  }

  getEnumsValues() {
    this.getEnumValuesApi('SmsAggregator')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.SmsAggregatorsEnumValues = values));
  }
  //#endregion

  getPaginationData() {
    this.pageConfig.loading = true;

    this.paginationModel.totalPages = Math.ceil(
      (this.isTableFiltered
        ? this.filteredItems?.length
        : this.baseItems?.length) / this.paginationModel?.pageSize
    );
    this.paginationModel.totalCount = this.isTableFiltered
      ? this.filteredItems?.length
      : this.baseItems?.length;
    this.paginationModel.pageNumber = this.paginationModel.pageNumber
      ? this.paginationModel.pageNumber
      : 1;
    this.paginationModel.pageSize = this.paginationModel.pageSize
      ? this.paginationModel.pageSize
      : 30;
    this.paginationModel.hasNextPage =
      this.paginationModel.pageNumber < this.paginationModel.totalPages
        ? true
        : false;
    this.paginationModel.hasPreviousPage =
      this.paginationModel.pageNumber > 1 ? true : false;

    this.items = (
      this.isTableFiltered ? this.filteredItems : this.baseItems
    ).slice(
      (this.paginationModel.pageNumber - 1) * this.paginationModel.pageSize,
      this.paginationModel.pageNumber * this.paginationModel.pageSize
    );
    this.pageConfig.loading = false;
  }

  getComparisonObjects(model: ComparisonObjectsWithLogicalOperators[]) {
    this.comparisonObjects = model;
    this.paginationModel.pageNumber = 1;
    this.filterItems();
  }

  changePageNumber(pageNumber: number) {
    this.paginationModel.pageNumber = pageNumber;
    this.paginationModel.firstIndex =
      (pageNumber - 1) * this.paginationModel.pageSize + 1;
    this.getPaginationData();
  }

  changePageSize(pageSize: number) {
    this.paginationModel.pageSize = pageSize;
    this.paginationModel.pageNumber = 1;
    this.getPaginationData();
  }

  filterItems() {
    this.filteredItems = [];
    this.isTableFiltered = false;

    this.comparisonObjects.forEach((searchItem) => {
      searchItem.comparisonObjects.forEach((comparisonObjects) => {
        if (comparisonObjects.field == 'number') {
          this.isTableFiltered = true;
          this.filteredItems = [...this.baseItems].filter((item) =>
            (item[comparisonObjects.field] as string).includes(
              comparisonObjects.value
            )
          );
        }
        if (comparisonObjects.field == 'mobileOperator') {
          this.isTableFiltered = true;
          this.filteredItems = [...this.baseItems].filter(
            (item) => item[comparisonObjects.field] == comparisonObjects.value
          );
        }
      });
    });

    this.paginationModel.pageNumber = 1;
    this.getPaginationData();
  }

  onClose() {
    this.output_closePage.emit(true);
  }

  getPaginationApi(): Observable<any> {
    throw new Error('Method not implemented.');
  }
}
